import {
  NativeStackHeaderProps,
  Stack,
  useLocalSearchParams,
} from 'expo-router';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet, View } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import ExpoNavigationBar from 'shared/components/vxl/navigation/ExpoNavigationBar/ExpoNavigationBar';
import { isIOS } from 'shared/constants/platform';
import { useViewDidFocusScreenAnalyticsEvent } from 'shared/hooks/analytics/useViewDidFocusAnalytics';
import useDismissToRootTab, {
  Tabs,
} from 'shared/hooks/useDismissToRootTab/useDismissToRootTab';
import ErrorScreen, {
  ErrorScreenType,
} from 'shared/patterns/vxl/errors/ErrorScreen/ErrorScreen';
import theme from 'shared/styles/theme';

type SubCategory = 'va_application' | 'va_disbursement';
type StepName =
  | 'employment_info'
  | 'va_application_submission'
  | 'va_amount_selection'
  | 'va_disbursement'
  | 'va_disbursement_submission';

const AdvanceError = () => {
  const { t: translatedText } = useTranslation('advance', {
    keyPrefix: 'error',
  });
  const insets = useSafeAreaInsets();
  const dismissToTab = useDismissToRootTab();

  const goHome = () => {
    dismissToTab(Tabs.HOME);
  };

  const { subcategory, error_type, error_description, step_name } =
    useLocalSearchParams<{
      subcategory: SubCategory;
      error_type: string;
      error_description: string;
      step_name: StepName;
    }>();

  useViewDidFocusScreenAnalyticsEvent({
    key: 'varo-advance/error-custom',
    customAttributes: {
      subcategory: subcategory,
      error_type: error_type,
      error_description: error_description,
      step_name: step_name,
    },
  });

  return (
    <View
      style={[
        styles.container,
        {
          paddingTop: insets.top,
          paddingBottom: isIOS
            ? insets.bottom
            : insets.bottom + theme.spacing.m,
        },
      ]}
    >
      <Stack.Screen
        options={{
          header: (props: NativeStackHeaderProps) => (
            <ExpoNavigationBar
              {...props}
              options={{
                headerShown: false,
                headerBackVisible: false,
              }}
            />
          ),
        }}
      />
      <ErrorScreen
        screenType={ErrorScreenType.Error}
        messageHeadline={translatedText('title')}
        messageBody={translatedText('body')}
        primaryButton={{
          title: translatedText('button'),
          onPress: () => {
            goHome();
          },
        }}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    backgroundColor: theme.color.background.primary,
    flex: 1,
    padding: theme.spacing.m,
  },
});

export default AdvanceError;
